import { defineComponent as m, openBlock as t, createElementBlock as o, mergeProps as d, unref as e, renderSlot as p, createElementVNode as l, createCommentVNode as V } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, f = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconWallet"
}, _ = /* @__PURE__ */ m({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(H) {
    const r = H, { bind: s, weight: n } = i(r);
    return (A, a) => (t(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      p(A.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", u, a[0] || (a[0] = [
        l("path", { d: "M196,136a16,16,0,1,1-16-16A16,16,0,0,1,196,136Zm40-36v80a32,32,0,0,1-32,32H60a32,32,0,0,1-32-32V60.92A32,32,0,0,1,60,28H192a12,12,0,0,1,0,24H60a8,8,0,0,0-8,8.26v.08A8.32,8.32,0,0,0,60.48,68H204A32,32,0,0,1,236,100Zm-24,0a8,8,0,0,0-8-8H60.48A33.72,33.72,0,0,1,52,90.92V180a8,8,0,0,0,8,8H204a8,8,0,0,0,8-8Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", Z, a[1] || (a[1] = [
        l("path", {
          d: "M224,80V192a8,8,0,0,1-8,8H56a16,16,0,0,1-16-16V56A16,16,0,0,0,56,72H216A8,8,0,0,1,224,80Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M216,64H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24,24,0,0,0,32,56V184a24,24,0,0,0,24,24H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm0,128H56a8,8,0,0,1-8-8V78.63A23.84,23.84,0,0,0,56,80H216Zm-48-60a12,12,0,1,1,12,12A12,12,0,0,1,168,132Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        l("path", { d: "M216,64H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24,24,0,0,0,32,56V184a24,24,0,0,0,24,24H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm-36,80a12,12,0,1,1,12-12A12,12,0,0,1,180,144Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", f, a[3] || (a[3] = [
        l("path", { d: "M216,66H56a10,10,0,0,1,0-20H192a6,6,0,0,0,0-12H56A22,22,0,0,0,34,56V184a22,22,0,0,0,22,22H216a14,14,0,0,0,14-14V80A14,14,0,0,0,216,66Zm2,126a2,2,0,0,1-2,2H56a10,10,0,0,1-10-10V75.59A21.84,21.84,0,0,0,56,78H216a2,2,0,0,1,2,2Zm-28-60a10,10,0,1,1-10-10A10,10,0,0,1,190,132Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", k, a[4] || (a[4] = [
        l("path", { d: "M216,64H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24,24,0,0,0,32,56V184a24,24,0,0,0,24,24H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm0,128H56a8,8,0,0,1-8-8V78.63A23.84,23.84,0,0,0,56,80H216Zm-48-60a12,12,0,1,1,12,12A12,12,0,0,1,168,132Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", h, a[5] || (a[5] = [
        l("path", { d: "M216,68H56a12,12,0,0,1,0-24H192a4,4,0,0,0,0-8H56A20,20,0,0,0,36,56V184a20,20,0,0,0,20,20H216a12,12,0,0,0,12-12V80A12,12,0,0,0,216,68Zm4,124a4,4,0,0,1-4,4H56a12,12,0,0,1-12-12V72a19.86,19.86,0,0,0,12,4H216a4,4,0,0,1,4,4Zm-32-60a8,8,0,1,1-8-8A8,8,0,0,1,188,132Z" }, null, -1)
      ]))) : V("", !0)
    ], 16));
  }
});
export {
  _ as default
};
